import { Star, Quote } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Marie L.",
      location: "Treillières",
      date: "2025-03",
      rating: 5,
      text: "Jacky est intervenu en urgence pour une fuite sur notre toiture après les tempêtes de février. Travail impeccable, devis respecté et chantier propre. Je recommande vivement ce professionnel sérieux et à l'écoute.",
      service: "Réparation d'urgence"
    },
    {
      name: "Jean-Pierre M.",
      location: "Saint-Mars-du-Désert",
      date: "2025-01",
      rating: 5,
      text: "Rénovation complète de notre toiture en tuiles avec isolation des combles. L'équipe est professionnelle, les travaux ont été réalisés dans les délais annoncés. Prestation de qualité, je recommande vivement !",
      service: "Rénovation complète"
    },
    {
      name: "Sophie D.",
      location: "Vigneux-de-Bretagne",
      date: "2024-11",
      rating: 5,
      text: "Pose de 2 Velux et réfection de la zinguerie. Travail soigné, conseils avisés sur le choix des fenêtres. Jacky a su nous orienter vers les meilleures solutions adaptées à nos besoins. Très satisfaits du résultat !",
      service: "Pose Velux & Zinguerie"
    },
    {
      name: "Thomas B.",
      location: "Nantes",
      date: "2024-09",
      rating: 5,
      text: "Démoussage et traitement hydrofuge de notre toiture. Intervention rapide et résultat impeccable. Notre toiture a retrouvé son aspect d'origine. Un artisan de confiance sur Nantes !",
      service: "Démoussage & Hydrofuge"
    },
    {
      name: "Catherine R.",
      location: "Grandchamp-des-Fontaines",
      date: "2024-07",
      rating: 5,
      text: "Remplacement de notre ancienne toiture en ardoise. Chantier mené avec sérieux, respect des normes et accompagnement sur les aides MaPrimeRénov'. Une équipe professionnelle qui connaît son métier !",
      service: "Remplacement toiture ardoise"
    },
    {
      name: "Patrick V.",
      location: "La Chapelle-sur-Erdre",
      date: "2024-05",
      rating: 5,
      text: "Isolation extérieure de notre toiture avec un gain énergétique immédiat. Jacky nous a guidés dans le choix des matériaux et nous avons bénéficié des aides. Excellent service !",
      service: "Isolation toiture"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-background to-background-gray relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl animate-float"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary/5 rounded-full blur-3xl animate-float" style={{ animationDelay: '1.5s' }}></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 bg-primary/10 text-primary font-semibold rounded-full mb-6 text-sm uppercase tracking-wider animate-bounce-in">
            Témoignages Clients
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6 text-primary animate-fade-in">
            Ils Nous Font Confiance
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto animate-fade-in" style={{ animationDelay: '0.1s' }}>
            Plus de 500 clients satisfaits en Loire-Atlantique
          </p>
          <div className="flex items-center justify-center gap-2 mt-6">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-8 h-8 fill-yellow-400 text-yellow-400" />
            ))}
            <span className="ml-3 text-2xl font-bold text-primary">5.0/5</span>
            <span className="text-muted-foreground ml-2">(47 avis)</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-card p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover-lift relative overflow-hidden"
              data-animate="fade-in"
              data-animate-delay={index * 100}
            >
              <Quote className="absolute top-4 right-4 w-12 h-12 text-accent/10" />
              
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              
              <p className="text-muted-foreground mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              
              <div className="pt-4 border-t border-border">
                <p className="font-bold text-primary text-lg">{testimonial.name}</p>
                <p className="text-sm text-muted-foreground">{testimonial.location}</p>
                <div className="mt-2 inline-block px-3 py-1 bg-accent/10 text-accent text-xs font-semibold rounded-full">
                  {testimonial.service}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16 p-10 bg-gradient-to-br from-accent/10 to-secondary/10 rounded-2xl max-w-4xl mx-auto">
          <h3 className="text-2xl md:text-3xl font-bold text-primary mb-4">
            Rejoignez nos clients satisfaits !
          </h3>
          <p className="text-lg text-muted-foreground mb-6">
            Devis gratuit et intervention rapide sur toute la Loire-Atlantique
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:0646702617"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-accent text-white font-bold rounded-xl hover:bg-accent/90 hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Appelez-nous : 06.46.70.26.17
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-primary font-bold rounded-xl hover:bg-accent/10 hover:scale-105 transition-all duration-300 shadow-lg border-2 border-accent"
            >
              Demander un devis gratuit
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;